var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language"},_vm._l((_vm.langs),function(lang,i){return _c('p',{key:`Lang${i}`,attrs:{"value":lang},on:{"click":function($event){_vm.$i18n.locale = lang}}},[_c('label',{class:{ 'a' : _vm.$i18n.locale !== lang }},[_vm._v(" "+_vm._s(_vm.contentLangs[i])+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }